module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-100 d-flex align-center main-select"
  }, [_c('el-select', _vm._b({
    staticClass: "w-100 select-address",
    class: {
      'not-map': !_vm.visibleMap
    },
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.selected
    }
  }, 'el-select', _vm.$attrs, false), _vm._l((_vm.optionsComputed), function(item, indexItem) {
    return _c('el-option', {
      key: indexItem,
      attrs: {
        "label": item.itemText,
        "value": item.itemValue
      }
    })
  })), _vm._v(" "), (_vm.noMap) ? _c('el-button', {
    staticClass: "address-btn",
    class: {
      'disable-style': _vm.noLocationFound
    },
    style: (("background-color:" + (_vm.globalColors.primary) + ";border:0.1rem solid " + (_vm.globalColors.primary))),
    attrs: {
      "disabled": _vm.noLocationFound
    },
    on: {
      "click": _vm.openModalAction
    }
  }, [_c('img', {
    staticClass: "location",
    attrs: {
      "src": _vm.location,
      "alt": "localizador"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('section', [_c('modal-component', {
    attrs: {
      "title": _vm.modalTitle,
      "before-close": _vm.closeModalAction,
      "visible": _vm.openModal
    }
  }, [_c('map-component', {
    attrs: {
      "zoom": _vm.zoom,
      "all-markers": _vm.warehouseMarkers,
      "location": _vm.itemSelectedPosition
    },
    on: {
      "choosed-warehouse": _vm.choosedWarehouse
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fa48338","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectAddressComponent.vue
// module id = 1115
// module chunks = 32